export default {
      id: "flag-ch-usage",
      viewBox: "0 10 36 20",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#flag-ch",
      toString: function () {
        return this.url;
      }
    }